<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'App',
  watch: {
    '$route' (val) {
      if (val.meta.openInit) {
        this.openInstallInit(val)
      }
    }
  },
  mounted () {
    // Android微信中，借助WeixinJSBridge对象来阻止字体大小调整
    (function() {
      if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
        handleFontSize()
      } else {
        if (document.addEventListener) {
          document.addEventListener("WeixinJSBridgeReady", handleFontSize, false)
        } else if (document.attachEvent) {
          //IE浏览器，非W3C规范
          document.attachEvent("onWeixinJSBridgeReady", handleFontSize)
        }
      }
      function handleFontSize() {
        // 设置网页字体为默认大小
        WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : 0 })
        // 重写设置网页字体大小的事件
        WeixinJSBridge.on('menu:setfont', function() {
          WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : 0 })
        })
      }
    })()
  }
}
</script>

<style>
#app {
  font-family: 'PingFang SC', 'Avenir', Helvetica, Arial, sans-serif;
  width: 100%;
  background: white;
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/app.vue